<template>
   <Table :context="self" :data="tableData" :columns="tableColumns" stripe border></Table>
</template>
<script>
import { paymethodindex } from "../../api/paymethodapi";
import privilegesbtn from "../../constant/privilegesbtn.js";
export default {
  data() {
    return {
      self: this,
      tableData: [],
      total: 0,
      page: 1,
      pagesize: 10,
      isupdte: privilegesbtn("/paymethod/update"),
      tableColumns: [
        {
          title: "支付代码",
          key: "code",
          align: "center",
        },
        {
          title: "支付名称",
          key: "name",
          align: "center"
        },

        {
          title: "额外参数",
          align: "center",
          key: "data"
        },
        {
          title: "上次修改时间",
          align: "center",
          key: "modifytime"
        },
        {
          title: "是否可用",
          key: "isvalid",
          align: "center",
          render: (h, params) => {
            var isvalid = params.row.isvalid == 0 ? "不是" : "是";
            return h("span", isvalid);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    disabled:(!this.isupdte)
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.show(params.row);
                    }
                  }
                },
                "修改"
              )
              //   h(
              //     "Button",
              //     {
              //       props: {
              //         type: "error",
              //         size: "small"
              //       },
              //       on: {
              //         click: () => {
              //           this.remove(params.row.id);
              //         }
              //       }
              //     },
              //     "删除"
              //   )
            ]);
          }
        }
      ]
    };
  },
  methods: {
    privilegesbtn:privilegesbtn,
    show(params){
      if(params){
        this.$router.push({path:"/paymethodupdate",query:params})
      }
    },
    getlist() {
      var par = {};
      this.$Loading.start();
      
      paymethodindex(par).then(res => {
        this.$Loading.finish();
        var Data = res.data;
        this.total = Data.data.total;
        this.tableData = Data.data.data;
      });
    }
  },
  mounted() {
    this.getlist()
  }

};
</script>



// WEBPACK FOOTER //
// src/pages/System/paymethodindex.vue